import { TextChatMessage } from '../xislivechat/models/text-chat-message';
import { Injectable } from '@angular/core';
import { BcRestApi } from '../api/rest-api';
import { MessageGroupModel } from 'shared/services/message-group/message-group.model';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';
import { DynamicQueryObservable } from 'common/dynamicquery/dynamic-query-observable.model';

@Injectable()
export class TextChatMessagesService {
  constructor(private dynamicQuery: DynamicQueryAdapterService,
              private dynamicQueryDecorator: DynamicQueryDecoratorService,
              private bcRestApi: BcRestApi) {
  }

  observePastTextChatMessagesByTextChatId(textChatId): DynamicQueryObservable<TextChatMessage> {
    if (!textChatId) {
      throw new Error('Missing textChatId');
    }

    const messagesObservable = this.dynamicQuery.getQuery('textChatMessagesByTextChatID', { TextChatID: textChatId });
    return this.dynamicQueryDecorator.create(messagesObservable, TextChatMessage.wrap);
  }

  sendTextChatMessage(textChatMessage): any {
    return this.bcRestApi.sendTextChatMessage(textChatMessage);
  }

  getTextChatMessages(chatId): Promise<MessageGroupModel[]> {
    return this.bcRestApi.getTextChatMessages(chatId)
      .then(messages => {
        return Array.from(messages, (msg: any) => TextChatMessage.wrap({
          // This property transformation is required, because the REST API returns JavaScript-friendly property
          // names, but the TextChatMessage model class is also used for the results of dynamic queries.
          data: {
            TextChatMessageID: msg.id,
            Name: msg.name,
            PersonType: msg.personType,
            PersonID: msg.personId,
            Created: msg.createdAt,
            Text: msg.text,
            JsonData: msg.jsonData
          }
        }));
      });
  }
}
